import React from "react";
import { CheckIcon, CloseIcon, MinusIcon } from "../Icons";
import classNames from "classnames";
import "./status.scss";
import style from "../../scss/export.module.scss";
import defaultIconSettings from "../Icons/defaultIconSettings";

export type TStatus = {
    type?: "success" | "error" | "not-available" | "no";
    size?: number;
    ariaLabel?: string;
};

export const Status = ({ type = "success", size = defaultIconSettings.size, ariaLabel }: TStatus) => {
    const success = type === "success";
    const error = type === "error";
    const notAvailable = type === "not-available";
    const no = type === "no";

    return (
        <div
            title={ariaLabel}
            className={classNames(
                "c-status-circle",
                { "c-status-circle--success": success },
                { "c-status-circle--not-available": notAvailable },
                { "c-status-circle--error": error }
            )}
            style={{ padding: size && size / 3 }}
            aria-label={ariaLabel}
        >
            <div aria-hidden="true">
                {success && <CheckIcon color={style.successDarkColor} size={size} />}
                {notAvailable && <MinusIcon color={style.darkGreyColor} size={size} />}
                {error && <CloseIcon color={style.alertColor} size={size} />}
                {no && <CloseIcon color={style.darkGreyColor} size={size} />}
            </div>
        </div>
    );
};

export default Status;
